import { Button } from "../button/Button"
import { Portal } from "../portal/Portal"
import styles from "./modal.module.css"

type Props = {
  title: string
  onClose: () => void
  onConfirm: () => void
  confirmText?: string
  children: React.ReactNode
}

export const ConfirmModal = ({
  title,
  onClose,
  onConfirm,
  confirmText = "Confirm",
  children,
}: Props) => {
  return (
    <Portal id="modal">
      <div className={styles.modalOverlay} onClick={onClose}>
        <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
          <div className={styles.modalHeader}>
            <h2>{title}</h2>
            <button className={styles.closeButton} onClick={onClose}>
              ×
            </button>
          </div>
          <div className={styles.modalBody}>{children}</div>
          <div className={styles.modalFooter}>
            <Button onClick={onClose}>Atcelt</Button>
            <Button onClick={onConfirm}>{confirmText}</Button>
          </div>
        </div>
      </div>
    </Portal>
  )
}
